import script from "./RegisterView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegisterView.vue?vue&type=script&lang=ts&setup=true"

import "./RegisterView.vue?vue&type=style&index=0&id=2a7f1ca2&lang=css"

const __exports__ = script;

export default __exports__